import { CarePlan } from 'models/ServiceUsersTypes'

/** Shown when any care-plan file is still training (`status === 'PENDING'`). */
export const PENDING_CARE_PLAN_REASON =
  'The uploaded care plan is currently being processed. The “Run New Audit” option will be enabled once processing is completed.'

/** Package has care-plan audit off — upload, delete, bulk select and audits are blocked. */
export const CARE_PLAN_PACKAGE_DISABLED_REASON = 'Care plan audit is disabled for this organization'

/** Organisation monthly care-plan audit allowance is spent. */
export const CARE_PLAN_QUOTA_EXCEEDED_REASON = 'Care plan audit limit exceeded for this organization'

/** An audit was already generated for the currently uploaded care plan(s). */
export const ALREADY_VIEWED_AUDIT_REASON = 'The audit for this care plan has already been completed.'

export const hasPendingCarePlan = (carePlans?: CarePlan[] | null) =>
  (carePlans || []).some(plan => plan.status === 'PENDING')

/**
 * Monthly-cap tip for table + Run New Audit.
 * Treats exhausted or remaining === 0 as at capacity (not unlimited).
 */
export const formatCarePlanAuditQuotaReason = (allowance?: {
  exhausted?: boolean
  remaining?: number | null
  unlimited?: boolean
  limit?: number | null
} | null) => {
  if (!allowance || allowance.unlimited) return undefined
  const atCap = Boolean(allowance.exhausted) || allowance.remaining === 0
  if (!atCap || allowance.limit == null) return undefined
  return CARE_PLAN_QUOTA_EXCEEDED_REASON
}

/**
 * Full block reason for table + Run New Audit tooltips.
 * Order: deactivated → training → quota.
 * Package off reports a 0 limit, so it must win over quota.
 */
export const auditBlockedReasonForUser = (
  carePlans?: CarePlan[] | null,
  quotaReason?: string,
  options?: { packageEnabled?: boolean },
) => {
  if (options?.packageEnabled === false) return CARE_PLAN_PACKAGE_DISABLED_REASON
  if (hasPendingCarePlan(carePlans)) return PENDING_CARE_PLAN_REASON
  if (quotaReason) return quotaReason
  return undefined
}
